import { useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import axios, { AxiosError } from 'axios'
import toast from 'react-hot-toast'
import LogoIcon from './logo-icon.png'
import LogoPro from './logo-pro.png'
import Spinner from './ios-spinner.min.svg'

function HomeIcon() {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3343 30.3071V25.8346C13.3343 24.7012 14.2559 23.7805 15.3974 23.7733H19.5889C20.7355 23.7733 21.6651 24.6962 21.6651 25.8346V30.2941C21.665 31.2771 22.4639 32.076 23.454 32.0831H26.3136C27.6491 32.0866 28.9312 31.5622 29.8768 30.6259C30.8224 29.6895 31.3538 28.418 31.3538 27.0921V14.3875C31.3538 13.3164 30.8756 12.3005 30.0481 11.6133L20.3332 3.89981C18.635 2.55064 16.2096 2.59422 14.5617 4.00352L5.05573 11.6133C4.18909 12.2802 3.6711 13.2992 3.64551 14.3875V27.0791C3.64551 29.8427 5.90211 32.0831 8.68576 32.0831H11.4801C11.9568 32.0866 12.4152 31.901 12.7535 31.5675C13.0918 31.2341 13.2821 30.7804 13.2821 30.3071H13.3343Z"
        fill="white"
      />
    </svg>
  )
}

function ImageIcon() {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.819 32.0832H11.1802C6.23746 32.0832 2.91699 28.6165 2.91699 23.4561V11.5451C2.91699 6.38458 6.23746 2.9165 11.1802 2.9165H23.8205C28.7632 2.9165 32.0837 6.38458 32.0837 11.5451V23.4561C32.0837 28.6165 28.7632 32.0832 23.819 32.0832Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3997 12.6508C16.3997 14.6487 14.7737 16.2748 12.7758 16.2748C10.7764 16.2748 9.15183 14.6487 9.15183 12.6508C9.15183 10.6529 10.7764 9.02539 12.7758 9.02539C14.7737 9.02539 16.3997 10.6529 16.3997 12.6508ZM28.293 20.5442C28.6328 20.8738 28.8764 21.25 29.0368 21.6511C29.5224 22.8644 29.2701 24.3227 28.751 25.5244C28.1355 26.955 26.9572 28.0356 25.4726 28.5081C24.8135 28.7196 24.1222 28.81 23.4324 28.81H11.2101C9.99387 28.81 8.91762 28.5271 8.03533 27.9963C7.48262 27.6638 7.38492 26.8981 7.79471 26.3994C8.48012 25.5681 9.15679 24.734 9.83929 23.8925C11.1401 22.2825 12.0166 21.8158 12.9907 22.2256C13.386 22.3948 13.7826 22.65 14.191 22.9183C15.2789 23.6388 16.7912 24.6275 18.7832 23.5542C20.1449 22.8096 20.9354 21.5355 21.6233 20.4265L21.6372 20.4042C21.6835 20.33 21.7294 20.2558 21.7752 20.1818C22.0091 19.8038 22.2395 19.4315 22.5005 19.0888C22.8243 18.6644 24.026 17.3373 25.5791 18.2823C26.5693 18.8773 27.402 19.6823 28.293 20.5442Z"
        fill="black"
      />
    </svg>
  )
}

function UploadIcon() {
  return (
    <svg
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1379_2065)">
        <path
          d="M33.7705 3.88867H14.668V11.8103H37.8503V7.9669C37.8503 5.71795 36.0201 3.88867 33.7705 3.88867Z"
          fill="#8EA807"
        />
        <path
          d="M22.9567 13.0291H0.614258V5.67865C0.614258 2.98524 2.80602 0.794434 5.50038 0.794434H12.644C13.3541 0.794434 14.0381 0.944067 14.6595 1.22523C15.5274 1.61631 16.273 2.2609 16.796 3.10311L22.9567 13.0291Z"
          fill="#2F25F7"
        />
        <path
          d="M42.2549 14.6746V38.3516C42.2549 40.6034 40.4218 42.4349 38.1691 42.4349H4.70011C2.44735 42.4349 0.614258 40.6034 0.614258 38.3516V10.5903H38.1691C40.4218 10.5903 42.2549 12.4225 42.2549 14.6746Z"
          fill="#D6FF00"
        />
        <path
          d="M42.2549 14.6746V38.3516C42.2549 40.6034 40.4218 42.4349 38.169 42.4349H21.4346V10.5903H38.169C40.4218 10.5903 42.2549 12.4225 42.2549 14.6746Z"
          fill="#D6FF00"
        />
        <path
          d="M32.3883 26.513C32.3883 32.5533 27.4745 37.4674 21.4349 37.4674C15.3952 37.4674 10.4814 32.5533 10.4814 26.513C10.4814 20.4736 15.3952 15.5596 21.4349 15.5596C27.4745 15.5596 32.3883 20.4736 32.3883 26.513Z"
          fill="#E7ECFC"
        />
        <path
          d="M32.388 26.513C32.388 32.5533 27.4742 37.4674 21.4346 37.4674V15.5596C27.4742 15.5596 32.388 20.4736 32.388 26.513Z"
          fill="#CED9F9"
        />
        <path
          d="M24.9653 26.6469C24.7369 26.8404 24.457 26.9347 24.1796 26.9347C23.8324 26.9347 23.4874 26.7877 23.2459 26.5011L22.6547 25.8003V30.3887C22.6547 31.0622 22.1083 31.6086 21.4348 31.6086C20.7613 31.6086 20.2148 31.0622 20.2148 30.3887V25.8003L19.6236 26.5011C19.1884 27.0161 18.4192 27.0818 17.9042 26.6469C17.3896 26.2126 17.3235 25.4432 17.7578 24.9282L20.1726 22.0655C20.4874 21.6931 20.9468 21.479 21.4348 21.479C21.9227 21.479 22.3821 21.6931 22.697 22.0655L25.1117 24.9282C25.546 25.4432 25.4799 26.2126 24.9653 26.6469Z"
          fill="#212629"
        />
        <path
          d="M24.9651 26.6469C24.7367 26.8404 24.4568 26.9347 24.1794 26.9347C23.8322 26.9347 23.4872 26.7877 23.2457 26.5011L22.6545 25.8003V30.3887C22.6545 31.0622 22.1081 31.6086 21.4346 31.6086V21.479C21.9225 21.479 22.3819 21.6931 22.6968 22.0655L25.1115 24.9282C25.5458 25.4432 25.4798 26.2126 24.9651 26.6469Z"
          fill="#212629"
        />
      </g>
      <defs>
        <clipPath id="clip0_1379_2065">
          <rect
            width="41.6407"
            height="41.6407"
            fill="white"
            transform="translate(0.614258 0.794434)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

function DropzoneUpload() {
  return (
    <div
      className="border border-dashed border-[#546307] rounded-[10px] p-[32px] flex flex-col items-center justify-center gap-[10px] cursor-pointer hover:opacity-80 transition-opacity duration-[250ms]"
      style={{
        background:
          'linear-gradient(175deg, #212629 75.88%, rgba(214, 255, 0, 0.01) 600.42%)',
      }}
    >
      <UploadIcon />
      <div className="text-[14px] mt-[12px]">Dosyayı Sürükleyip Bırakın</div>
      <div className="text-[12px] flex items-center gap-[10px] before:content-[''] before:h-[1px] before:w-[50px] before:bg-[#546307] after:content-[''] after:h-[1px] after:w-[50px] after:bg-[#546307]">
        Yada
      </div>
      <div className="px-[12px] py-[6px] bg-[#D6FF00] text-[#212629] rounded-[10px] font-bold text-[12px]">
        Dosya Seçin
      </div>
    </div>
  )
}

export default function Photographer() {
  const mediaDropzoneRef = useRef<HTMLDivElement>(null)
  const inputRef = useRef<HTMLInputElement>(null)

  const [selectedFilesLength, setSelectedFilesLength] = useState(0)
  const [uploadedFilesLength, setUploadedFilesLength] = useState(0)

  const params = useParams()

  const onMediaUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target

    if (files?.length && params.uuid) {
      setSelectedFilesLength(files.length)

      const uploadPromises = Array.from(files)
        .filter((file) => {
          const fileType = file.type.split('/')[0]
          return fileType === 'image'
        })
        .map(async (file) => {
          const formData = new FormData()

          formData.append('file_upload', file)

          try {
            await axios.post(
              `https://faceapi.texttonext.com/face/store?event_code=${params.uuid}`,
              formData
            )
            setUploadedFilesLength((prev) => prev + 1)
          } catch (e) {
            const error = e as AxiosError

            if (error.response) {
              const data = error.response.data as {
                error: {
                  status: number
                  message: string
                }
              }

              toast.dismiss()
              toast.error(data.error.message)
            }
          }
        })

      await Promise.all(uploadPromises)

      setSelectedFilesLength(0)
      setUploadedFilesLength(0)

      mediaDropzoneRef.current?.style.setProperty('opacity', '1')
    }
  }

  return (
    <div className="w-full h-full bg-[#000000] text-[#fff] p-[30px] flex items-start gap-[30px] font-morebi">
      <div
        className="flex flex-col items-center w-[80px] h-full border border-[#D6FF000D] rounded-[10px]"
        style={{
          background:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(214, 255, 0, 0.00) 100%)',
        }}
      >
        <div className="flex flex-col flex-1 justify-center">
          <div className="cursor-pointer w-[80px] h-[80px] flex items-center justify-center">
            <ImageIcon />
          </div>
          <div className="cursor-pointer w-[80px] h-[80px] flex items-center justify-center">
            <HomeIcon />
          </div>
        </div>
        <div className="w-[80px] h-[80px] flex items-center justify-center">
          <img src={LogoIcon} alt="logo" />
        </div>
      </div>
      <div className="flex-1 h-full overflow-y-auto">
        <div className="text-[24px] text-[#D6FF00] font-normal mb-[24px]">
          (AAA ORGANİZASYON) - Cansu & Selim Wedding 24 Temmuz 2025
        </div>
        <div className="flex items-start gap-[30px]">
          <div className="flex flex-col gap-[30px] w-8/12">
            <div className="flex items-center gap-[30px] justify-start">
              <div
                className="px-[25px] h-[100px] flex items-center gap-[10px] rounded-[10px]"
                style={{
                  background:
                    'linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(214, 255, 0, 0.00) 100%)',
                }}
              >
                <div
                  className="w-[60px] h-[60px] flex items-center justify-center rounded-full"
                  style={{
                    background:
                      'linear-gradient(180deg, rgba(214, 255, 0, 0.08) 19.5%, rgba(24, 25, 24, 0.00) 100%)',
                  }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      width="24"
                      height="24"
                      fill="url(#paint0_linear_1192_8505)"
                      fillOpacity="0.1"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M15.85 2.50065C16.481 2.50065 17.111 2.58965 17.71 2.79065C21.401 3.99065 22.731 8.04065 21.62 11.5806C20.99 13.3896 19.96 15.0406 18.611 16.3896C16.68 18.2596 14.561 19.9196 12.28 21.3496L12.03 21.5006L11.77 21.3396C9.48102 19.9196 7.35002 18.2596 5.40102 16.3796C4.06102 15.0306 3.03002 13.3896 2.39002 11.5806C1.26002 8.04065 2.59002 3.99065 6.32102 2.76965C6.61102 2.66965 6.91002 2.59965 7.21002 2.56065H7.33002C7.61102 2.51965 7.89002 2.50065 8.17002 2.50065H8.28002C8.91002 2.51965 9.52002 2.62965 10.111 2.83065H10.17C10.21 2.84965 10.24 2.87065 10.26 2.88965C10.481 2.96065 10.69 3.04065 10.89 3.15065L11.27 3.32065C11.3618 3.36962 11.4649 3.44445 11.554 3.50912C11.6104 3.55009 11.6612 3.58699 11.7 3.61065C11.7163 3.62028 11.7329 3.62996 11.7496 3.63972C11.8354 3.68977 11.9247 3.74191 12 3.79965C13.111 2.95065 14.46 2.49065 15.85 2.50065ZM18.51 9.70065C18.92 9.68965 19.27 9.36065 19.3 8.93965V8.82065C19.33 7.41965 18.481 6.15065 17.19 5.66065C16.78 5.51965 16.33 5.74065 16.18 6.16065C16.04 6.58065 16.26 7.04065 16.68 7.18965C17.321 7.42965 17.75 8.06065 17.75 8.75965V8.79065C17.731 9.01965 17.8 9.24065 17.94 9.41065C18.08 9.58065 18.29 9.67965 18.51 9.70065Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div>
                  <div className="text-[22px] opacity-[0.6]">178+</div>
                  <div className="text-[14px] opacity-[0.6]">
                    Yüklenen Fotoğraf Sayısı
                  </div>
                </div>
              </div>
              <div
                className="px-[25px] h-[100px] flex items-center gap-[10px] rounded-[10px]"
                style={{
                  background:
                    'linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(214, 255, 0, 0.00) 100%)',
                }}
              >
                <div
                  className="w-[60px] h-[60px] flex items-center justify-center rounded-full"
                  style={{
                    background:
                      'linear-gradient(180deg, rgba(214, 255, 0, 0.08) 19.5%, rgba(24, 25, 24, 0.00) 100%)',
                  }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M13.164 4.08252C13.4791 4.08684 13.7949 4.09117 14.1119 4.09441C17.5172 4.09441 20 6.52216 20 9.87476V14.1811C20 17.5337 17.5172 19.9615 14.1119 19.9615C12.7478 19.9904 11.3837 20 10.0098 20C8.63592 20 7.25221 19.9904 5.88813 19.9615C2.48283 19.9615 0 17.5337 0 14.1811V9.87476C0 6.52216 2.48283 4.09441 5.89794 4.09441C7.18351 4.07514 8.49853 4.05588 9.83317 4.05588V3.8921C9.83317 3.22736 9.2738 2.68786 8.60648 2.68786H7.63494C6.52601 2.68786 5.62316 1.80154 5.62316 0.722543C5.62316 0.327553 5.95682 0 6.35918 0C6.77134 0 7.09519 0.327553 7.09519 0.722543C7.09519 1.01156 7.34053 1.24277 7.63494 1.24277H8.60648C10.0883 1.25241 11.2954 2.43738 11.3052 3.88247V4.06551C11.9239 4.06551 12.5425 4.074 13.164 4.08252ZM8.85182 12.7457H7.82139V13.7669C7.82139 14.1618 7.48773 14.4894 7.08538 14.4894C6.67321 14.4894 6.34936 14.1618 6.34936 13.7669V12.7457H5.30913C4.90677 12.7457 4.57311 12.4277 4.57311 12.0231C4.57311 11.6281 4.90677 11.3006 5.30913 11.3006H6.34936V10.289C6.34936 9.89403 6.67321 9.56647 7.08538 9.56647C7.48773 9.56647 7.82139 9.89403 7.82139 10.289V11.3006H8.85182C9.25417 11.3006 9.58783 11.6281 9.58783 12.0231C9.58783 12.4277 9.25417 12.7457 8.85182 12.7457ZM13.0226 11.1175H13.1207C13.5231 11.1175 13.8567 10.7996 13.8567 10.395C13.8567 10 13.5231 9.67245 13.1207 9.67245H13.0226C12.6104 9.67245 12.2866 10 12.2866 10.395C12.2866 10.7996 12.6104 11.1175 13.0226 11.1175ZM14.7007 14.4316H14.7988C15.2012 14.4316 15.5348 14.1137 15.5348 13.7091C15.5348 13.3141 15.2012 12.9865 14.7988 12.9865H14.7007C14.2875 12.9865 13.9647 13.3141 13.9647 13.7091C13.9647 14.1137 14.2875 14.4316 14.7007 14.4316Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div>
                  <div className="text-[22px] opacity-[0.6]">178+</div>
                  <div className="text-[14px] opacity-[0.6]">
                    Davetlilerin yükledikleri
                  </div>
                </div>
              </div>
            </div>
            <div
              className="flex flex-col border border-[#D6FF000D] rounded-[10px] py-[32px] px-[50px]"
              style={{
                background:
                  'linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(214, 255, 0, 0.00) 100%)',
              }}
            >
              <div className="text-[20px] font-bold mb-[12px]">
                Etkinlik Fotoğrafları
              </div>
              <div className="text-[14px] mb-[32px]">
                Buraya yükleyeceğiniz tüm fotoğraflar etkinlik sahibinin
                hesabına otomatik <br /> olarak yüklenecektir.
              </div>
              <div
                className="border border-dashed border-[#546307] rounded-[10px] p-[32px] flex flex-col items-center justify-center gap-[10px] cursor-pointer hover:opacity-80 transition-opacity duration-[250ms] [&>*]:pointer-events-none"
                style={{
                  background:
                    'linear-gradient(175deg, #212629 75.88%, rgba(214, 255, 0, 0.01) 600.42%)',
                }}
                ref={mediaDropzoneRef}
                onClick={() => inputRef.current?.click()}
                onDragOver={(e) => {
                  e.preventDefault()
                }}
                onDragEnter={() => {
                  mediaDropzoneRef.current?.style.setProperty('opacity', '0.8')
                }}
                onDragLeave={() => {
                  mediaDropzoneRef.current?.style.setProperty('opacity', '1')
                }}
                onDrop={(e) => {
                  e.preventDefault()
                  onMediaUpload({
                    target: { files: e.dataTransfer.files },
                  } as React.ChangeEvent<HTMLInputElement>)
                }}
              >
                {selectedFilesLength > 0 && (
                  <div className="text-[24px] mt-[12px] flex flex-col items-center gap-[20px]">
                    <img
                      src={Spinner}
                      alt="spinner"
                      className="w-[36px] h-[36px]"
                    />
                    {uploadedFilesLength}/{selectedFilesLength} dosya yüklendi.
                  </div>
                )}
                {selectedFilesLength === 0 && (
                  <>
                    <input
                      ref={inputRef}
                      type="file"
                      accept="image/*,video/*,.wav,.aif,.aiff,.flac,.alac,.aac,.ogg,.mp3,.m4a"
                      className="hidden"
                      onChange={onMediaUpload}
                      multiple
                    />
                    <UploadIcon />
                    <div className="text-[14px] mt-[12px]">
                      Dosyayı Sürükleyip Bırakın
                    </div>
                    <div className="text-[12px] flex items-center gap-[10px] before:content-[''] before:h-[1px] before:w-[50px] before:bg-[#546307] after:content-[''] after:h-[1px] after:w-[50px] after:bg-[#546307]">
                      Yada
                    </div>
                    <div className="px-[12px] py-[6px] bg-[#D6FF00] text-[#212629] rounded-[10px] font-bold text-[12px]">
                      Dosya Seçin
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-[30px] w-4/12">
            <div className="flex items-center justify-center h-[100px] shrink-0">
              <img src={LogoPro} alt="logo-pro" />
            </div>
            <div
              className="flex flex-col border border-[#D6FF000D] rounded-[10px] py-[32px] px-[50px]"
              style={{
                background:
                  'linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(214, 255, 0, 0.00) 100%)',
              }}
            >
              <div className="text-[20px] font-bold mb-[12px]">
                Etkinlik Videosu
              </div>
              <div className="text-[14px] mb-[32px]">
                Buraya yükleyeceğiniz video etkinlik <br />
                sahibinin hesabına otomatik olarak yüklenecektir.
              </div>
              <DropzoneUpload />
            </div>
          </div>
        </div>
      </div>
      <div className="absolute right-[80px] bottom-[50px] flex flex-col text-center text-[12px]">
        Bir sorun mu yaşıyorsun?
        <b className="text-[#D6FF00] text-[18px] mt-[5px]">
          Müşteri Temsilcine Ulaş
        </b>
      </div>
    </div>
  )
}
